import { render, staticRenderFns } from "./totalDocumentByCategory.vue?vue&type=template&id=9d40028a&"
import script from "./totalDocumentByCategory.vue?vue&type=script&lang=js&"
export * from "./totalDocumentByCategory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports